import React from "react";
import * as Icons from "lucide-react";

// Fork du Stepper de FormCard.js (composant privé là-bas) : mêmes conventions
// visuelles et d'accessibilité (pastilles numérotées, courant=indigo plein,
// complété=vert avec coche, verrouillé=gris désactivé, aria-current="step",
// libellés aria-label descriptifs) — adapté aux étapes d'onboarding
// (accessible tant que déjà atteinte, pas seulement la précédente).
export default function OnboardingStepper({ steps, current, maxReached, onJump }) {
  return (
    <ol className="flex items-center gap-1.5" aria-label="Progression de l'onboarding">
      {steps.map((s, i) => {
        const done = s.done;
        const isCurrent = i === current;
        const clickable = i <= maxReached && !isCurrent;
        return (
          <React.Fragment key={s.key}>
            <li>
              <button type="button" onClick={() => clickable && onJump(i)} disabled={!clickable}
                data-testid={`onboarding-step-${i}`}
                aria-current={isCurrent ? "step" : undefined}
                aria-label={`Étape ${i + 1} sur ${steps.length} : ${s.title}${done ? ", complétée" : ""}${isCurrent ? ", en cours" : ""}`}
                className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 transition-colors
                  ${isCurrent ? "bg-marine text-white" : done ? "bg-bleu text-white cursor-pointer" : clickable ? "bg-marine-50 text-marine cursor-pointer" : "bg-marine-50 text-muet cursor-not-allowed"}`}>
                {done ? <Icons.Check size={16} aria-hidden="true" /> : i + 1}
              </button>
            </li>
            {i < steps.length - 1 && <li aria-hidden="true" className={`flex-1 h-px min-w-[16px] ${i < current ? "bg-bleu" : "bg-marine/15"}`} />}
          </React.Fragment>
        );
      })}
    </ol>
  );
}
